<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат BLS Banner</div>
    <div class="markup__h markup__h_3">Формат представляет из себя череду вопросов (минимум 1) и финальный экран в конце.</div>

    <br>
    <div class="markup__h markup__h_orange"><strong>Демо формата:</strong></div>
    <ul class="markup__ul markup__ul_small">
      <li v-if="!isMobile"><router-link to="/desktop/brandLift2" target="_blank" class="link">Desktop</router-link></li>
      <li><router-link to="/mobile/brandLift" target="_blank" class="link">Mobile</router-link></li>
    </ul>

    <br>

    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Каждый вопрос должен содержать следующие сведения:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Заголовок (опционально)</li>
          <li>Текст вопроса</li>
          <li>Варианты ответов</li>
        </ul>
      </li>
      <li>
        Каждый вопрос может содержать не более 5 (минимум 2) обычных вариантов ответа и один эксклюзивный (например, "ничего из перечисленного").
      </li>
      <li>
        Для каждого вопроса необходимо указать (да/нет) возможность выбора нескольких вариантов ответа.
      </li>
      <li>
        Для каждого вопроса необходимо указать (да/нет) перемешивание ответов при отображении.
        <div class="attention attention_warn">
          <div class="attention__title">Внимание:</div>
          <p>Перемешиваются только обычные варианты ответа.</p>
        </div>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Лимиты</strong>
          <p>(элемент / рекомендуемый размер / максимальный размер)</p>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Заголовок: до 80 символов</li>
          <li>Текст вопроса: до 80 символов / до 150 символов</li>
          <li>Текст ответа: до 30 символов / до 150 символов</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'bls',
  data() {
    return {
      isMobile,
    };
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
